import { createReducer } from '@reduxjs/toolkit'
import { RtmParameters } from 'interfaces/api/rtmParameters.interfaces'
import { ValidationErrorsApi } from 'packages/api'
import { createBuilder } from 'packages/redux-toolkit'

import {
  createRtmParameters,
  getAllRtmParameters,
  removeRtmParameters,
  setRtmParametersValidationErrors,
  setSingleRtmParameters,
  updateRtmParameters,
} from './actions'

interface RtmParametersState {
  list: {
    loading: boolean
    items: RtmParameters[]
  }
  single: {
    loading: boolean
    item: RtmParameters | null
  }
  validation: ValidationErrorsApi | null
}

const initialState: RtmParametersState = {
  list: {
    loading: false,
    items: [],
  },
  single: {
    loading: false,
    item: null,
  },
  validation: null,
}

export const rtmParametersReducer = createReducer(initialState, (builder) => {
  createBuilder(builder)
    .addCase(getAllRtmParameters.pending, (state) => {
      state.list.loading = true
    })
    .addCase(getAllRtmParameters.rejected, (state) => {
      state.list.loading = false
    })
    .addCase(getAllRtmParameters.fulfilled, (state, { payload }) => {
      state.list.loading = false
      state.list.items = payload
    })

    .addCase(setRtmParametersValidationErrors, (state, { payload }) => {
      state.validation = payload
    })

    .addCase([setSingleRtmParameters], (state, { payload }) => {
      state.single.loading = false
      state.single.item = payload
    })

    .addCase([createRtmParameters.pending, removeRtmParameters.pending, updateRtmParameters.pending], (state) => {
      state.single.loading = true
    })
    .addCase([createRtmParameters.rejected, removeRtmParameters.rejected, updateRtmParameters.rejected], (state) => {
      state.single.loading = false
    })
    .addCase([createRtmParameters.fulfilled, removeRtmParameters.fulfilled, updateRtmParameters.fulfilled], (state) => {
      state.single.loading = false
    })
})
